import styled from 'styled-components';

export const Header = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLargeSemibold}
`;

export const Description = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  color: ${(props) => props.theme.newPalette.neutral.N600};
  padding-bottom: 20px;
  text-align: center;
`;

export const FormContainer = styled.div`
  width: 100%;
`;
